import React from "react";
import { Sun, Moon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/theme/ThemeProvider";

// Sleek single-tap theme toggle. Sun icon when light, Moon icon when dark,
// with a horizontal slider rail. Compact, no labels.
export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-pressed={isDark}
      className={cn(
        "relative inline-flex items-center w-14 h-7 rounded-full transition-colors duration-150",
        "border focus:outline-none focus:ring-2 focus:ring-sky-700/30",
        isDark
          ? "bg-stone-800 border-stone-700"
          : "bg-stone-100 border-stone-200 hover:bg-stone-200"
      )}
    >
      {/* Sliding knob */}
      <span
        className={cn(
          "absolute top-0.5 h-6 w-6 rounded-full bg-white shadow-sm transition-transform duration-200 flex items-center justify-center",
          isDark ? "translate-x-7" : "translate-x-0.5"
        )}
        data-testid="theme-toggle-knob"
      >
        {isDark ? (
          <Moon size={12} strokeWidth={2} className="text-sky-700" />
        ) : (
          <Sun size={12} strokeWidth={2} className="text-amber-600" />
        )}
      </span>

      {/* Inactive icon hint on the opposite side */}
      <span className={cn("absolute pointer-events-none flex items-center justify-center w-6 h-6 top-0.5 opacity-50", isDark ? "left-0.5" : "right-0.5")}>
        {isDark ? <Sun size={10} className="text-stone-500" /> : <Moon size={10} className="text-stone-400" />}
      </span>
    </button>
  );
}
